/**
 * OVERRIDE Maps/View.jsx (Arkus)
 * REASON: both Volto Light Theme (block width/alignment) and volto-gdpr-privacy
 * (cookie consent) override this file. Keep VLT's view, behind the consent gate.
 */
import React from 'react';
import MapsView from '@kitconcept/volto-light-theme/components/Blocks/Maps/View';
import ConditionalEmbed from 'volto-gdpr-privacy/components/ConditionalEmbed/ConditionalEmbed';

const View = (props) => (
  <ConditionalEmbed code={props.data?.url}>
    <MapsView {...props} />
  </ConditionalEmbed>
);

export default View;
